import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
const token = accessToken

//apply base url for axios
const API_URL = "/"
//const API_URL = "https://localhost:8443/"

const dev = {
  apiUrl : 'https://localhost:8443/'
  //apiUrl : 'https://flamingo.tekymart.com/'
};

const prod = {
  apiUrl : '/'
};

const envConfigs = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

const axiosApi = axios.create({
  //baseURL: API_URL,
  baseURL: envConfigs.apiUrl,
  //baseURL: 'https://flamingo.tekymart.com/',
  //withCredentials: true
})

//axiosApi.defaults.headers.common["Authorization"] = token
axiosApi.defaults.withCredentials = true;

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function postArray(url, data, config = {}) {
  return axiosApi
    .post(url,  data , { ...config })
    .then(response => response.data)
}

export async function postImage(url, data, config = {}) {
  axiosApi.defaults.headers.common["Content-Type"] = "multipart/form-data"
  const result = await axiosApi
    .post(url,  data , { ...config })
    .then(response => response.data)
    //console.log('result:'+JSON.stringify(result))
    return result;
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
